import * as React from 'react';
import { joinClasses } from '../../../Utils/className.util';
// @ts-ignore
import styles from './HStack.module.scss';

interface HStackProps {
	children: React.ReactElement | React.ReactElement[];
	alignCenter?: boolean;
	space?: number;
	childSpread?: boolean;
}

const HStack: React.FC<HStackProps> = props => {
	const { children, space, alignCenter, childSpread = true } = props;

	return (
		<div
			className={joinClasses([
				styles.container,
				alignCenter ? styles.alignCenter : undefined,
			])}>
			{React.Children.map(children, (child, index) => {
				return (
					<div className={childSpread ? styles.item : undefined}>{child}</div>
				);
			})}
		</div>
	);
};

export default HStack;
